export default __webpack_public_path__ + "static/no-permission-fa1074b0910f82c915a429640364ad94.svg";